import {API} from '../../api/API';
import { PAYMENTS_HISTORY} from '../../config/config';
import { stringDateToUTC } from 'util/Date';


export const getPayments = async (params ) => {
    let payments = await API.get(PAYMENTS_HISTORY,{
        params: params
    });
    return payments.data;
}

export const getPayment = async (paymentId) => {
    let paymentResp = await API.get(PAYMENTS_HISTORY+"/"+paymentId);
    return paymentResp.data;
}

export const refundPayment = async (paymentId) => {
    let refundResp = await API.delete(PAYMENTS_HISTORY+"/"+paymentId);
    return refundResp.data;
}

export const approveOfflinePayment = async(paymentId, paymentDate, receiptDate, paymentStatus) => {
    let approveUrl = PAYMENTS_HISTORY+"/"+paymentId+"/actions/approve";
    let paymentUtc = null; 
    let receiptUtc = null;

    if (paymentDate) { 
        paymentUtc = stringDateToUTC(paymentDate);
    }
    if (receiptDate){
        receiptUtc = stringDateToUTC(receiptDate);
    }
    await API.put(approveUrl,{
        paymentDate: paymentUtc,
        receiptDate: receiptUtc,
        paymentStatus: paymentStatus
    });
}

export const getAccountNumber = (accounts, id) => {
    let accountNumber = accounts.filter(account => account.id == id).map(account => account.number)
    return accountNumber[0];
}

export const getAccountTypeNameFromAccounts = (accounts, id, accountTypes) => {
    let filteredAccounts = accounts.filter(account => account.id == id);
    let account = filteredAccounts[0];
    let accountTypeName = accountTypes.filter(accountType => accountType.id === account.accountTypeId)
        .map(filteredAccountType => (filteredAccountType.accountTypeDisplayName));
    return accountTypeName;
}


export const getAccountTypeDisplayName = (id, accountTypes) => {
    let accountTypeName = accountTypes.filter(accountType => accountType.id === id)
        .map(filteredAccountType => (filteredAccountType.accountTypeDisplayName));

    return accountTypeName;    
}

